import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { forkJoin, map, Observable } from 'rxjs';

import { FilterDataService } from '@services/filter-data.service';
import { FilterDataMessage } from '@models/filter-data.model';
import { SaveFormService } from '@services/save-form.service';
import { GlobalsService } from '@services/globals.service';

export const carValuationDetailResolver: ResolveFn<Observable<{ filterData: FilterDataMessage }>> = (route, state) => {
  const filterDataService = inject(FilterDataService);
  const saveFormService = inject(SaveFormService);
  const globalsService = inject(GlobalsService);
  const id = route.queryParams['id'];
  const internalToken = route.queryParams['internal-token'];


  globalsService.setHeaderHashLogged(internalToken);
  return forkJoin({
    filterData: filterDataService.getFilter(),
    formData: saveFormService.fetchForm(id),
  }).pipe(
    map((data) => {
      const filterData = data.filterData;
      const formData = data.formData;
      return { filterData, formData };
    }),
  );
};
